import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  searchSection: {
    marginBottom: 40,
    marginTop: 25,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0
    }
  },
  expandableBoxRowContainer: {
    marginTop: 10
  },
  searchInput: {
    marginBottom: 12
  },
  itemsBox: {
    paddingLeft: 20,
    paddingRight: 0,
    paddingTop: 10,
    paddingBottom: 16,
    marginBottom: 20,
    marginTop: 75,
    border: '1px solid #e7e7e7',
    borderRadius: 16,
    height: 'calc(100vh - 550px)',
    minHeight: 350,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      marginTop: 10
    }
  },
  listView: {
    height: '100%',
    overflowY: 'auto'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))

export default useStyles
